const updateFrequencyStr = {
  toastr: 'Frequency updated',
  toastr1: 'has been updated successfully',
  toastrError: 'Attendance already registered',
  toastrError1: 'Enter another name'
};

export default updateFrequencyStr;
